import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'markant-platform-ui-page-header',
  standalone: true,
  imports: [],
  template: `
    <h2 [id]="idContent">
      <ng-content />
    </h2>
    <ng-content select="[actions]" />
  `,
  styleUrl: './ui-page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiPageHeaderComponent {
  @Input() idContent = '';
}
